import { motion } from "framer-motion";
import { CalendarCheck, Images, MessageCircle } from "lucide-react";

const STEPS = [
  {
    nr: "01",
    icon: CalendarCheck,
    title: "Anfragen",
    text: "Wähl im Kalender deinen Wunschtermin oder schreib mir über das Formular. Du bekommst sofort eine Bestätigung — und ich melde mich innerhalb von 24 Stunden.",
  },
  {
    nr: "02",
    icon: MessageCircle,
    title: "Kennenlernen",
    text: "Wir besprechen kurz per WhatsApp oder Telefon, was du dir vorstellst: Ort, Stimmung, wer dabei ist. Ganz entspannt, ohne Fachchinesisch.",
  },
  {
    nr: "03",
    icon: Images,
    title: "Shooting & Galerie",
    text: "Wir treffen uns und haben eine gute Zeit. Wenige Tage später bekommst du deine private Online-Galerie — zum Anschauen, Teilen und Herunterladen in voller Qualität.",
  },
];

export const Process = () => {
  return (
    <section id="ablauf" data-testid="process-section" className="mx-auto max-w-[1440px] px-6 py-28 lg:px-12 lg:py-40">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9 }}
        className="mb-14"
      >
        <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.35em] text-gold">So läuft's ab</p>
        <h2 className="max-w-2xl font-serif text-3xl font-light tracking-tight text-white sm:text-4xl lg:text-5xl">
          In drei Schritten <span className="italic text-zinc-400">zu deinen Bildern.</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.nr}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.12 }}
            data-testid={`process-step-${s.nr}`}
            className="group border border-white/10 bg-ink2/40 p-8 transition-all duration-500 hover:-translate-y-1 hover:border-gold/40 hover:bg-ink2 lg:p-10"
          >
            <div className="flex items-center justify-between">
              <s.icon size={22} className="text-gold" />
              <span className="font-serif text-5xl italic leading-none text-white/10 transition-colors group-hover:text-gold/30">
                {s.nr}
              </span>
            </div>
            <h3 className="mt-8 font-serif text-2xl text-white">{s.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-zinc-400">{s.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
